import * as React from "react";
const SvgSearch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <rect
      width={12}
      height={12}
      x={0.625}
      y={0.625}
      stroke="#89909D"
      strokeWidth={1.25}
      rx={6}
    />
    <path
      fill="#89909D"
      d="M13.683 14.567a.625.625 0 1 0 .884-.884l-.442.442zm.442-.442.442-.442-3-3-.442.442-.442.442 3 3z"
    />
  </svg>
);
export default SvgSearch;
